import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Input, Pagination } from 'antd';
import { app } from '../../config';
import { dateConverter } from '../../utils/utcDateConversion';

const Transactions = () => {
  const { t } = useTranslation(['common']);
  let navigate = useNavigate();


  let { Search } = Input;
  const [editbtn, setEditBtn] = useState('none');
  const [search, setSearch] = useState('');
  const [transactions,setTransactions]=useState([])
  const [commonData,setCommonData]=useState([])
  const [pagesCount, setPagesCount] = useState(0);
  const [current, setCurrent] = useState(1);
  const [searchShow, setSearchShow] = useState(false);
  const [renderList, setRenderList] = useState([]);
  const [tableShow, setTableShow] = useState(true);
  const [err, setErr] = useState('');
  let searchedUser;
  // const editPerm = (e) => {
  //   localStorage.setItem('permissionId', JSON.stringify(e.permId));
  //   navigate('/permission/edit', { replace: true });
  // };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user.userType === 'A') setEditBtn('block');
    const fetchTrans = async () => {
      const limit = 1000;
      const offset = 0;
      const tr = await axios.post(`${app.URL}/trans/view`, { limit, offset });
      console.log(tr);
      let transResp = tr ? tr.data : [];
      console.log(transResp.data);
      let convertedObj = dateConverter(transResp.data, 'donationDate');
      // permResponse.data?setOrgsResp(permResponse.data.data):" ";
      convertedObj?setTransactions(convertedObj) : " ";
      convertedObj?setCommonData(convertedObj) : " ";
      convertedObj?setPagesCount(convertedObj.length):" ";
      convertedObj?setRenderList(convertedObj.slice(0,10)) : console.log('Not Set');
    };
    fetchTrans();
  }, []);
  const handleSearch = async () => {
    try {
      const result = search ? await axios.get(`${app.URL}/user/search/${search}`) : [];
      searchedUser = result.data;
    } catch (e) {
      console.log('Error');
      if (e.message) setErr(e.response.data.message);
      setTableShow(false);
    }

    console.log(searchedUser);
    if (searchedUser) {
      setSearchShow(true);
      setRenderList(searchedUser);
    }
    console.log(searchedUser);
  };
  const onSearch = async (value) => {
    console.log(value);
    try {
      const result = await axios.get(`${app.URL}/trans/search/${value}`);
      console.log(result);
      let convertedObj=[];
      result.data? convertedObj = dateConverter(result.data.data, 'donationDate'):" ";
      // let searchedTrans = result.data.data;
      setCommonData(convertedObj);
      setRenderList(convertedObj.slice(0,10));
      setPagesCount(convertedObj.length);
    } catch (e) {
      console.log('Error');
      if (e.message) setErr(e.response.data.message);
      setTableShow(false);
    }
  };
  const handleSearchChange = (e) => {
    if (!e.target.value) {
      setCommonData(transactions);
      setRenderList(transactions.slice(0, 10));
      setPagesCount(transactions.length);
      setTableShow(true);
    }
    setSearch(e.target.value);
  };
  // useEffect(() => {
  //   if (!searchShow) setRenderList(transactions);
  // }, [handleSearch]);
  const onChange = async (page, pageSize) => {
    console.log(page, pageSize);
    setCurrent(page);
    if (!page) page = 1;
    let limit = pageSize;
    let reqObj = {
      limit,
      offset: limit * (page - 1),
    };
    setRenderList(commonData.slice(reqObj.offset, reqObj.offset + reqObj.limit));
    
  };
  console.log(commonData);
  return (
    <div className=''>
      {/* <div className='row'>
        <div className='row'>
          <Navbar />
        </div>
        <div className='row'>
          <div className='col-lg-3 col-md-3 col-sm-3'>
            <NewSideBar />
          </div> */}
          <div className=' ml-3 col-lg-12 col-md-12 col-sm-12 '>
            <div className='row text-center'>
              <div className='col-lg-11 mt-4'>
                <Search
                  placeholder='input search text'
                  onChange={handleSearchChange}
                  onSearch={onSearch}
                  style={{
                    width: 300,
                  }}
                />
              </div>
            </div>
            <div className='row mt-2'>
              <div className='col-lg-10 col-md-10 col-sm-10 fs-3 fw-bold'>{t('Donations')}</div>
            </div>
            <div className='col-lg-11 col-md-12 col-sm-12 '>
              <div class=' styled-table '>
                <table class='table text-black'>
                  <thead class='thead-light'>
                    <tr>
                      <th>{t('Organization')}</th>
                      <th>{t('Donation Date')}</th>
                      <th>{t('Cause')}</th>
                      <th>{t('Donation')}</th>
                      <th>{t('Donor Name')}</th>
                      <th> </th>
                    </tr>
                  </thead>
                  <tbody>
                    {renderList
                      ? renderList.map((output) => (
                          <tr>
                            <td>{output.organizationName}</td>
                            <td>{output.donationDate}</td>
                            <td>{output.cause}</td>
                            <td>{output.amount}</td>
                            <td>{output.donorName}</td>
                            <td>
                              {/* <EditTwoTone displayName="edit" twoToneColor="blue" style={{fontSize:"20px"}} onClick={()=>{editUser(output)}} /> */}
                              {/* <button type='button' style={{ display: editbtn }} class='btn btn-primary color1 button' onClick={() => editOrg(output)}>
                     {t('Edit')}
                   </button> */}
                            </td>
                          </tr>
                        ))
                      : ' '}
                  </tbody>
                </table>
              </div>
            </div>
            <Pagination style={{ marginTop: '10px' }} onChange={onChange} defaultCurrent={current} pageSize={10} total={pagesCount} />
          </div>
        </div>
    //   </div>
    // </div>
  );
};

export default Transactions;
